import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import EventHostsListView from "./event_hosts-list.html";
import EventHostsEditView from "./event_hosts-edit.html";


angular.module("eventHosts", ['ui.bootstrap.contextMenu'])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('event_hosts', {
                url: "/event_hosts",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('event_hosts.list', {
                url: "/list",
                controller: "EventHostsListCtrl",
                template: EventHostsListView,
                requiredPermission: ["EVENT_HOSTS_READ"]
            })
            .state('event_hosts.edit', {
                url: "/edit/:id",
                controller: "EventHostsEditCtrl",
                template: EventHostsEditView,
                requiredPermission: ["EVENT_HOSTS_READ"]
            })
    }])
    ;